import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

const checkPermissionsWithRoles = (roles: any[], code: string, actionTypes: string[], checkSubModule: boolean = false): boolean => {
  return roles.some((roleItem: any) => {
    if (roleItem.module && roleItem.module.length > 0) {
      const foundModule = roleItem.module.find((moduleItem: any) => {
        return moduleItem.code === code;
      });
      if (foundModule && foundModule.permissions) {
        if (actionTypes.some((actionType) => foundModule.permissions[actionType])) {
          return true;
        }
      }

      if (checkSubModule) {
        const hasSubModulePermission = roleItem.module.some((moduleItem: any) => {
          const foundSubModule = moduleItem.subModules?.find((subModuleItem: any) => {
            return subModuleItem.code === code;
          });
          if (foundSubModule && foundSubModule.permissions) {
            return actionTypes.some((actionType) => foundSubModule.permissions[actionType]);
          }
          return false;
        });
        if (hasSubModulePermission) {
          return true;
        }
      }
    }
    return false;
  });
};

export const useCheckPermissions = (code: string, actionTypes: string[], checkSubModule: boolean = false): boolean => {
  const roles = useSelector((state: RootState) => state.roles.roles);
  return checkPermissionsWithRoles(roles, code, actionTypes, checkSubModule);
};

export const checkPermissions = useCheckPermissions;
